import { PERMISSION } from '@/constants/permission.constant';

const Add = () => import('@/views/promotion/Add.vue');
const AddBanner = () => import('@/views/banner/Add.vue');

export const promotionRoute = [
  {
    path: '/promotion/edit',
    name: 'promotion-edit',
    component: Add,
    meta: { requiresAuth: false, permissions: [PERMISSION.PROMOTION_READ] },
  },
  {
    path: '/banner/edit',
    name: 'banner-edit',
    component: AddBanner,
    meta: { requiresAuth: false, permissions: [PERMISSION.BANNER_READ] },
  },
];
